import { paygEndpoints } from '@/src/constants/endpoints';
import { apiService } from '@/src/services/api-service';
import { useAccountContext } from '@ovotech/ui-tools';
import { useQuery } from 'react-query';
import { paygQueryKeys } from './queryKeys';
import { TopupHistoryItem, TopupResponse } from './types';

type Params = {
  enabled?: boolean;
};

export const useAccountTopups = ({ enabled = true }: Params = {}) => {
  const { accountId } = useAccountContext();

  return useQuery({
    enabled: enabled && !!accountId,
    retry: 1,
    queryKey: paygQueryKeys.topups(accountId || ''),
    queryFn: () =>
      apiService.get<TopupResponse<'topups', TopupHistoryItem[]>>({
        url: paygEndpoints.topups(accountId!),
      }),
    select: ({ topups }) => topups,
  });
};
